import axiosInstance from "./AxiosInstance"

const API_URL = "/quizzes"

// Get all quizzes with pagination, search, searchField, trainerId, and batchId filters
export const getQuizzes = async (limit = 10, page = 1, search = "", searchField = "", trainerId = "", batchId = "", courseId="") => {
  // Build query parameters
  let queryParams = `?limit=${limit}&page=${page}`

  // Add search parameter if provided
  if (search) {
    queryParams += `&search=${encodeURIComponent(search)}`
  }

  // Add searchField parameter if provided
  if (searchField) {
    queryParams += `&searchField=${searchField}`
  }

  // Add trainerId filter if provided
  if (trainerId) {
    queryParams += `&trainerId=${trainerId}`
  }

  if(courseId) {
    queryParams += `&courseId=${courseId}`
  }

  // Add batchId filter if provided
  if (batchId) {
    queryParams += `&batchId=${batchId}`
  }

  console.log('API URL:', `${API_URL}${queryParams}`);

  try {
    const response = await axiosInstance.get(`${API_URL}${queryParams}`)
    return {
      data: response.data.data || response.data,
      pagination: response.data.pagination || {},
    }
  } catch (error) {
    console.error("Error fetching quizzes", error)
    throw error
  }
}

// Create a new quiz
export const createQuiz = async (quizData) => {
  try {
    const response = await axiosInstance.post(API_URL, quizData)
    return response.data
  } catch (error) {
    console.error("Error creating quiz", error)
    throw error
  }
}

// Update a quiz by ID
export const updateQuiz = async (quizId, quizData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${quizId}`, quizData)
    return response.data
  } catch (error) {
    console.error("Error updating quiz", error)
    throw error
  }
}

// Delete a quiz by ID
export const deleteQuiz = async (quizId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${quizId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting quiz", error)
    throw error
  }
}

// Get a quiz by ID
export const getQuizById = async (quizId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${quizId}`)
    return {
      data: response.data.data || response.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching quiz details", error)
    throw error
  }
}

// Add this function to your existing QuizService.js

// Get quizzes with pagination and courseId filter
// Get quizzes with pagination and courseId filter
export const getQuizzesWithFilters = async (limit = 20, page = 1, search = "",searchField = "", courseId = "", createdBy = "") => {
  try {
    let url = `/quizzes?limit=${limit}&page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
     if (searchField) {
    url += `&searchField=${searchField}`
  }
    if (courseId) {
      url += `&courseId=${courseId}`;
    }
    if (createdBy) {
      url += `&createdBy=${createdBy}`;
    }
    const response = await axiosInstance.get(url);
    return {
      data: response.data?.data || [],
      pagination: response.data?.pagination || {}
    };
  } catch (error) {
    console.error("Error fetching quizzes with filters:", error);
    throw error;
  }
};

export default {
  getQuizzes,
  createQuiz,
  updateQuiz,
  deleteQuiz,
  getQuizById,
  getQuizzesWithFilters,
}